import React, { useEffect, useRef } from 'react';
import { PlayerSambaVideosContainer } from './style';

declare let SpallaPlayer: any;

export interface PlayerEventListener {
  event: string;
  eventParam?: any;
  duration?: any;
}

interface PlayerSambaVideosProps {
  contentReference: string;
  controlsToEnable?: string[];
  captionTheme?: string[];
  resume?: number;
  getEventListeners?: (eventListener: PlayerEventListener) => void;
}

const PlayerSambaVideos: React.FC<PlayerSambaVideosProps> = ({
  contentReference,
  controlsToEnable,
  captionTheme,
  resume,
  getEventListeners,
}) => {
  const playerContainer = useRef<HTMLDivElement>(null);
  const configurePlayer = () => {
    if (contentReference) {
      const playerBaseUrl = process.env.REACT_APP_PLAYER_BASE_URL || '';
      if (playerBaseUrl) {
        let contentReferenceWithoutBaseUrl = contentReference.replace(
          'https://fast.player.liquidplatform.com/pApiv2/embed/',
          '',
        );
        contentReferenceWithoutBaseUrl = contentReferenceWithoutBaseUrl.replace(
          'https://beyond.spalla.io/player/?video=',
          '',
        );

        let midiaId = contentReferenceWithoutBaseUrl;
        const splittedReference = contentReferenceWithoutBaseUrl.split('/');
        if (splittedReference && splittedReference.length > 1) {
          midiaId = splittedReference[1];
        }

        SpallaPlayer.clearAllMediaEvents();

        new SpallaPlayer(playerContainer.current, {
          videoId: midiaId,
          controls: controlsToEnable,
          resume: resume || false,
          events: {
            '*': getEventListeners,
          },
        });
      }
    }
  };

  useEffect(() => {
    if (playerContainer && playerContainer.current) {
      if (Array.from(playerContainer.current.children).length > 0) {
        playerContainer.current.firstChild?.remove();
      }

      configurePlayer();
    }
  }, [playerContainer, contentReference]);

  return (
    <PlayerSambaVideosContainer
      ref={playerContainer}
    ></PlayerSambaVideosContainer>
  );
};

export default PlayerSambaVideos;
